// Keep SMS_REPLACEMENTS in sync with
// amplify/backend/function/sendPinPointMessage/src/smsText.js (HERA-9166).
// The backend swaps smart punctuation for plain GSM-7 characters before sending,
// so the counter has to count the swapped text.
const SMS_REPLACEMENTS = [
  [/[\u2010\u2011\u2012\u2013\u2014\u2015\u2212]/g, '-'],     // hyphens, en/em dashes, minus
  [/[\u2018\u2019\u201A\u201B\u2032\u00B4\u0060]/g, "'"],     // curly single quotes, prime, accents
  [/[\u201C\u201D\u201E\u201F\u2033\u00AB\u00BB]/g, '"'],     // curly double quotes, guillemets
  [/\u2026/g, '...'],                                          // ellipsis
  [/\u2022/g, '-'],                                            // bullet
  [/[\u00A0\u2002-\u200A\u202F\u205F\u3000]/g, ' '],           // non-breaking and fixed-width spaces
  [/[\u200B\u2060\uFEFF]/g, ''],                               // zero-width spaces (not ZWJ, which emoji use)
];

export function normalizeSmsText(text = '') {
  let normalized = text || '';
  for (const [pattern, replacement] of SMS_REPLACEMENTS) {
    normalized = normalized.replace(pattern, replacement);
  }
  return normalized;
}

function isCodificationGSM7(message='') {
  const regex = /^[0-9A-Za-z\r\n !"#\$%&'()*+,\-.\/:;<=>?@\[\\\]^_{}|~]+$/;
  return regex.test(message);
}

function calculateBytesGSM7(message='') {
  const specialCharacters = {
    '\u000C': true,  //line break
    '\u005E': true,  //Circumflex
    '\u007B': true,  // "{"
    '\u007D': true,  // "}"
    '\u005C': true,  // "\"
    '\u005B': true,  // "["
    '\u007E': true,  // "~"
    '\u005D': true,  // "]"
    '\u007C': true,  // |
    '\u20AC': true   // Euro
  };

  let bytes = 0;
  for (const char of message) {
    bytes += specialCharacters[char] ? 2 : 1;
  }
  return bytes;
}

function calculateBytesUTF16(message = '') {
  let totalBytes = 0;

  for (const char of message) {
    const codePoint = char.codePointAt(0);

    if (codePoint >= 0x10000 && codePoint <= 0x10FFFF) {
      // Characters that require more than 2 bytes in UTF-16
      totalBytes += 4;
    } else {
      totalBytes += 2;
    }
  }

  return totalBytes;
}

export function calculateBytes(message){
  const normalized = normalizeSmsText(message);
  if(isCodificationGSM7(normalized)){
    return calculateBytesGSM7(normalized);
  }
  return calculateBytesUTF16(normalized);
}
